import { render, staticRenderFns } from "./modifyCommission.vue?vue&type=template&id=6f676526&scoped=true"
import script from "./modifyCommission.vue?vue&type=script&lang=js"
export * from "./modifyCommission.vue?vue&type=script&lang=js"
import style0 from "./modifyCommission.vue?vue&type=style&index=0&id=6f676526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f676526",
  null
  
)

export default component.exports